
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Shop from "./Shop/Shop";
import CartPage from "./Shop/CartPage";
import CheckoutPage from "./Shop/CheckoutPage";
import ProductDetail from "./Shop/ProductDetail";

import Login from "./components/Auth/Login";
import Register from "./components/Auth/Register";
import ForgotPassword from "./components/Auth/ForgotPassword";
import ResetPassword from "./components/Auth/ResetPassword";

import AdminPanel from "./components/Admin/AdminPanel";
import UserPanel from "./components/UserPanel/UserPanel";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";

import BlogList from "./components/Blog/BlogList";
import BlogPost from "./components/Blog/BlogPost";
import BlogData from "./components/BlogData/posts.json";

import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";

import "./Shop/Shop.css";
import "./i18n";

// کامپوننت تغییر زبان
function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);

    if (lang === "fa") {
      document.documentElement.dir = "rtl";
      document.documentElement.lang = "fa";
    } else {
      document.documentElement.dir = "ltr";
      document.documentElement.lang = "en";
    }
  };

  return (
    <div
      // style={{
      //   position: "fixed",
      //   top: "10px",
      //   right: "10px",
      //   zIndex: 1000,
      //   display: "flex",
      //   gap: "10px",
      //   background: "white",
      //   padding: "8px 15px",
      //   borderRadius: "8px",
      //   boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
      // }}
    >
      {/* <button
        onClick={() => changeLanguage("en")}
        style={{
          padding: "5px 10px",
          cursor: "pointer",
          background: i18n.language === "en" ? "#007bff" : "#f0f0f0",
          color: i18n.language === "en" ? "white" : "black",
          border: "none",
          borderRadius: "5px",
        }}
      >
        🇬🇧 English
      </button>

      <button
        onClick={() => changeLanguage("fa")}
        style={{
          padding: "5px 10px",
          cursor: "pointer",
          background: i18n.language === "fa" ? "#007bff" : "#f0f0f0",
          color: i18n.language === "fa" ? "white" : "black",
          border: "none",
          borderRadius: "5px",
        }}
      >
        🇮🇷 فارسی
      </button> */}
    </div>
  );
}

export default function App() {
  const [currentPage, setCurrentPage] = useState("shop");
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedPostId, setSelectedPostId] = useState(null);

  // بررسی مسیر در هنگام بارگذاری اولیه
  useEffect(() => {
    const path = window.location.pathname;
    console.log("مسیر اولیه:", path);

    if (path === "/cart") {
      setCurrentPage("cart");
    } else if (path === "/checkout") {
      setCurrentPage("checkout");
    } else if (path === "/about") {
      setCurrentPage("about");
    } else if (path === "/contact") {
      setCurrentPage("contact");
    } else if (path === "/login") {
      setCurrentPage("login");
    } else if (path === "/register") {
      setCurrentPage("register");
    } else if (path === "/admin") {
      setCurrentPage("admin");
    } else if (path === "/user-panel") {
      setCurrentPage("user-panel");
    } else if (path === "/forgot-password") {
      setCurrentPage("forgot-password");
    } else if (path === "/reset-password") {
      setCurrentPage("reset-password");
    } else if (path === "/blog") {
      setCurrentPage("blog-list");
    } else if (path.startsWith("/blog/")) {
      const slug = path.split("/")[2];
      const post = BlogData.posts.find((p) => p.slug === slug);

      if (post) {
        setCurrentPage("blog-post");
        setSelectedPostId(post.id);
      } else {
        setCurrentPage("blog-list");
      }
    } else if (path.startsWith("/product/")) {
      const id = path.split("/")[2];
      setCurrentPage("product");
      setSelectedProductId(id);
    } else {
      setCurrentPage("shop");
    }
  }, []);

  // تابع برای تغییر صفحه
  const navigateTo = (page, id = null, type = null) => {
    if (type === "product" || page === "product") {
      setCurrentPage("product");
      setSelectedProductId(id);
      window.history.pushState({}, "", `/product/${id}`);
    } else if (type === "post" || page === "blog-post") {
      const post = BlogData.posts.find((p) => p.id === id);

      if (post) {
        setCurrentPage("blog-post");
        setSelectedPostId(id);
        window.history.pushState({}, "", `/blog/${post.slug}`);
      }
    } else if (page === "blog-list" || page === "blog") {
      setCurrentPage("blog-list");
      setSelectedPostId(null);
      window.history.pushState({}, "", "/blog");
    } else if (page === "cart") {
      setCurrentPage("cart");
      window.history.pushState({}, "", "/cart");
    } else if (page === "checkout") {
      setCurrentPage("checkout");
      window.history.pushState({}, "", "/checkout");
    } else if (page === "about") {
      setCurrentPage("about");
      window.history.pushState({}, "", "/about");
    } else if (page === "contact") {
      setCurrentPage("contact");
      window.history.pushState({}, "", "/contact");
    } else if (page === "login") {
      setCurrentPage("login");
      window.history.pushState({}, "", "/login");
    } else if (page === "register") {
      setCurrentPage("register");
      window.history.pushState({}, "", "/register");
    } else if (page === "admin") {
      setCurrentPage("admin");
      window.history.pushState({}, "", "/admin");
    } else if (page === "user-panel") {
      setCurrentPage("user-panel");
      window.history.pushState({}, "", "/user-panel");
    } else if (page === "forgot-password") {
      setCurrentPage("forgot-password");
      window.history.pushState({}, "", "/forgot-password");
    } else if (page === "reset-password") {
      setCurrentPage("reset-password");
      window.history.pushState({}, "", "/reset-password");
    } else {
      setCurrentPage("shop");
      setSelectedProductId(null);
      setSelectedPostId(null);
      window.history.pushState({}, "", "/");
    }
  };

  // گوش دادن به دکمه بازگشت مرورگر
  useEffect(() => {
    const handlePopState = () => {
      const path = window.location.pathname;
      console.log("popstate مسیر:", path);

      if (path === "/cart") {
        setCurrentPage("cart");
      } else if (path === "/checkout") {
        setCurrentPage("checkout");
      } else if (path === "/about") {
        setCurrentPage("about");
      } else if (path === "/contact") {
        setCurrentPage("contact");
      } else if (path === "/login") {
        setCurrentPage("login");
      } else if (path === "/register") {
        setCurrentPage("register");
      } else if (path === "/admin") {
        setCurrentPage("admin");
      } else if (path === "/user-panel") {
        setCurrentPage("user-panel");
      } else if (path === "/forgot-password") {
        setCurrentPage("forgot-password");
      } else if (path.startsWith("/reset-password")) {
        setCurrentPage("reset-password");
      } else if (path === "/blog") {
        setCurrentPage("blog-list");
        setSelectedPostId(null);
      } else if (path.startsWith("/blog/")) {
        const slug = path.split("/")[2];
        const post = BlogData.posts.find((p) => p.slug === slug);

        if (post) {
          setCurrentPage("blog-post");
          setSelectedPostId(post.id);
        } else {
          setCurrentPage("blog-list");
        }
      } else if (path.startsWith("/product/")) {
        const id = path.split("/")[2];
        setCurrentPage("product");
        setSelectedProductId(id);
      } else {
        setCurrentPage("shop");
        setSelectedProductId(null);
        setSelectedPostId(null);
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  // گرفتن پست انتخاب شده
  const getSelectedPost = () => {
    if (!selectedPostId) return null;
    return BlogData.posts.find((p) => p.id === selectedPostId);
  };

  // انتخاب صفحه مناسب برای رندر
  const renderPage = () => {
    console.log("صفحه فعلی:", currentPage);

    switch (currentPage) {
      case "cart":
        return <CartPage navigateTo={navigateTo} />;

      case "checkout":
        return <CheckoutPage navigateTo={navigateTo} />;

      case "about":
        return <About navigateTo={navigateTo} />;

      case "contact":
        return <Contact navigateTo={navigateTo} />;

      case "product":
        return (
          <ProductDetail
            navigateTo={navigateTo}
            productId={selectedProductId}
          />
        );

      case "login":
        return <Login navigateTo={navigateTo} />;

      case "register":
        return <Register navigateTo={navigateTo} />;

      case "admin":
        return <AdminPanel navigateTo={navigateTo} />;

      case "user-panel":
        return <UserPanel navigateTo={navigateTo} />;

      case "forgot-password":
        return <ForgotPassword navigateTo={navigateTo} />;

      case "reset-password":
        return <ResetPassword navigateTo={navigateTo} />;

      case "blog-list":
        return (
          <BlogList
            posts={BlogData.posts}
            navigateTo={navigateTo}
            onPostClick={(postId) => navigateTo("blog-post", postId, "post")}
          />
        );

      case "blog-post":
        return (
          <BlogPost
            post={getSelectedPost()}
            navigateTo={navigateTo}
            onBack={() => navigateTo("blog-list")}
          />
        );

      default:
        return <Shop navigateTo={navigateTo} />;
    }
  };

  return (
    <AuthProvider>
      <CartProvider>
        <LanguageSwitcher />
        {renderPage()}
      </CartProvider>
    </AuthProvider>
  );
}